import TemplatesCard from './templatesCard';

const templatesCards = (props) => {
  const templateElements = [];
  for (let i = 0; i < props.templates.length; i++) {
    const template = props.templates[i];

    templateElements.push(<TemplatesCard key={template.id} template={template} period={props.period} />);
  }

  return templateElements;
};

export default templatesCards;
